<template>
  <div>
    <div class="m-header">
      <div class="m-header__start">
        <router-link class="m-header__link m-header__link--home" to="/">
          <img src="~@/assets/images/icon__home.png"/>
        </router-link>
        <a class="m-header__link m-header__link--tips" @click="toggleShowTips">
          <img src="~@/assets/images/icon__tips.png"/>
        </a>
      </div>
      <div class="m-header__middle">
        <h1 class="m-header__title">Mega<br /> City</h1>
      </div>
      <div v-if="['gameOverWin'].indexOf($route.name) > -1"
         class="m-header__end m-header__end--static">
        <StaticLevels />
      </div>
      <div v-if="['gameOverLose'].indexOf($route.name) > -1"
         class="m-header__end m-header__end--static">
        <StaticLevels />
      </div>
      <div v-else class="m-header__end">
          <Score />
          <Rank />
          <Budget />
      </div>
    </div>
    <Tips />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Level from './Level';
import Rank from './Rank';
import Budget from './Budget';
import Score from './Score';
import Tips from '../Tips';
import StaticLevels from './StaticLevels';

export default {
  data() {
    return {
      showTips: this.$store.state.user.showTips,
      // time: this.$store.state.timer.time,
      // isRunning: this.$store.state.timer.isRunning,
      // interval: this.$store.state.timer.interval
    };
  },
  // watchers: {
  //   time() {
  //     return this.$store.state.timer.time;
  //   }
  // },
  methods: {
    ...mapActions(['toggleTimer', 'toggleShowTips']),
  },
  components: {
    Level,
    Score,
    Rank,
    Budget,
    Tips,
    StaticLevels,
  },
  computed: {
    ...mapGetters(['currentScore', 'currentTime', 'getStartConfidence', 'getEndConfidence', 'getShowTips']),
  },
};
</script>

<style lang='scss' scoped>
  $color-bg-blue: #83C4F4;
  .v-home {
    color: white;
    float: left;
    margin-right: 10px;
  }
  .v-tips {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: $color-bg-blue;
    height: 100%;
    width: 100%;
    z-index: 100;
  }
</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue